import omit from 'lodash/omit';
import {
  ADD_UPLOADING_FILE,
  REMOVE_ALL_UPLOADING_FILES,
  REMOVE_UPLOADING_FILE,
  RESET_STATE,
  SET_FIDELITY_FILTERABLE_YEAR_OPTION,
  SET_FILE_PENDING_CONFIRMATION,
  SET_IS_WORKFLOW,
  SET_STATE_PARAMS,
  StateParams,
} from './actions';
import { FilterableYearOption, filterableYears, ProviderType } from '../DocumentVault.meta';

export interface UploadFileData {
  file: File;
  path: string;
}

export interface DocumentVaultState {
  uploadingFiles: Record<string, UploadFileData>;
  isWorkflow: boolean;
  stateParams: StateParams;
  fidelityFilterableYearOption: FilterableYearOption;
  filePendingConfirmation: UploadFileData[] | null;
}

const initialState: DocumentVaultState = {
  uploadingFiles: {},
  isWorkflow: false,
  stateParams: {
    path: '',
    providerType: ProviderType.All,
    filterableByYear: false,
  },
  filePendingConfirmation: null,
  fidelityFilterableYearOption: filterableYears[0],
};

export const documentVaultReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ADD_UPLOADING_FILE: {
      return {
        ...state,
        uploadingFiles: {
          ...state.uploadingFiles,
          [payload.fileId]: {
            file: payload.file,
            path: payload.path,
          },
        },
      };
    }

    case REMOVE_UPLOADING_FILE: {
      return {
        ...state,
        uploadingFiles: omit(state.uploadingFiles, payload.fileId),
      };
    }

    case REMOVE_ALL_UPLOADING_FILES: {
      return {
        ...state,
        uploadingFiles: {},
      };
    }

    case SET_IS_WORKFLOW: {
      return {
        ...state,
        isWorkflow: payload.isWorkflow,
      };
    }

    case SET_STATE_PARAMS: {
      return {
        ...state,
        stateParams: payload.stateParams,
      };
    }

    case RESET_STATE: {
      return initialState;
    }

    case SET_FIDELITY_FILTERABLE_YEAR_OPTION: {
      return {
        ...state,
        fidelityFilterableYearOption: payload.fidelityFilterableYearOption,
      };
    }

    case SET_FILE_PENDING_CONFIRMATION: {
      return {
        ...state,
        filePendingConfirmation: payload,
      };
    }

    default: {
      return state;
    }
  }
};
